import { useEffect } from "react";
import { pendoTrackEventWithProperties } from "utils/pendo/pendoHelpers";
import type { LeaguesV2Events } from "./leaguesV2Events";

type ViewProps = Record<string, string | number | boolean | undefined>;

/**
 * Fires a view event on mount and again whenever a prop value changes (e.g. the
 * active tab). Props are compared by value, so an inline object won't re-fire.
 */
export function useTrackLeaguesV2View(
  event: LeaguesV2Events,
  props: ViewProps = {},
) {
  const key = JSON.stringify(props);
  useEffect(() => {
    pendoTrackEventWithProperties(event, JSON.parse(key) as ViewProps);
  }, [event, key]);
}
